<!-- <ng-container *ngIf="data">
<ng-template [ngTemplateOutlet]="template"></ng-template>
</ng-container>

<ng-template #template>
  <a *ngIf="!data">Eigener User wird beim Erstellen verwendet!</a> -->
  <div class="card">
    <div class="card-header card-header-squirrel">
      <h4>Neues Token erstellen</h4>
    </div>

    <div class="card-body">
      <form [formGroup]="userForm" novalidate>
        <hr>
          @if (data) {
            <h5>Benutzer, für den das Token bestimmt ist:</h5>
          }
          @if (!data) {
            <h5>Token wird für angemeldeten Benutzer erstellt!</h5>
          }
          @if (data) {
            <div class="row">
              <div class="col-md-12">
                @if (!isUserSelected) {
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="tokenUser" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                      (optionSelected)="optionSelected($event)">
                      @if (isLoading) {
                        <mat-option class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                      }
                      @if (!isLoading) {
                        @for (user of users; track user) {
                          <mat-option [value]="user">
                            <span><b>{{ user.userName }}</b> - {{ user.email }}</span>
                          </mat-option>
                        }
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                }
                @if (isUserSelected && selectedUserName != '') {
                  <a class="a-color">{{selectedUserName}}</a>
                }
              </div>
            </div>
          }

          <div class="row">
            <a>
              <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px"  matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
              (click)="cancel()" >Abbruch</button>
            </a>
            <span style="flex: 1 1 auto"></span>
            <a>
              <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Neues Token erstellen"
              (click)="add()" >Erstellen</button>
            </a>

          </div>
        </form>
      </div>
    </div>
  <!-- </ng-template> -->



